<script>
    let { linkObj } = $props();
</script> 

{#if linkObj?.url}
<svg class='svg-icon' style="position: relative; bottom: 1px">
    <use xlink:href='/i/fa.svg#{linkObj?.icon}'></use>
</svg>&nbsp;<a href={linkObj.url.match(/^\w+?:\/\//) ? linkObj.url : 'https://' + linkObj.url } target="_blank" rel="nofollow">{linkObj?.display}</a>
{/if}

<style>
a {
    color: var(--bulma-body-color);
    text-decoration: underline;
}
</style>
